import React from 'react';
import OrderListTable from "../../../components/OrderListTable";
import {ShippingStatus} from "../../../../types/order";
import {ProductType} from "../../../../types/product";

export const ReturnBooksOrderPage = () => {
    return <OrderListTable status={ShippingStatus.RETURN} type={ProductType.BOOK}/>;
}
